import { render, staticRenderFns } from "./ResourceSegmentsTab.vue?vue&type=template&id=0f052f60&scoped=true&lang=pug&"
import script from "./ResourceSegmentsTab.vue?vue&type=script&lang=js&"
export * from "./ResourceSegmentsTab.vue?vue&type=script&lang=js&"
import style0 from "./ResourceSegmentsTab.vue?vue&type=style&index=0&id=0f052f60&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f052f60",
  null
  
)

export default component.exports